import styles from "./Login.module.css";
import { Alert, Box, CircularProgress, FormControl, InputLabel, Modal } from "@mui/material";
import { WhiteInput } from "../../components/Inputs/InputText";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { Link, useNavigate } from "react-router-dom";
import LoginImage from "../../assets/images/Login.svg";
import { useForm, Controller } from 'react-hook-form';
import servLogin from "../../services/login/servLogin";
import { useGDDispatch } from "../../hooks";
import { login, setEmail } from "../../state/slices/userSlice";
import { Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { style as modalStyle } from "../../components/Loading/Loading";
import { linkStyle } from "../../components/Inputs/Link";
//import Logo from "../../assets/images/logo.png"

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { HelperText } from "../../components/Errors/HelperText";
import Popup from "../../components/Popup";
import EsqueceuSenha from "./EsqueceuSenha";
import { setImages } from "../../state/slices/imagesSlices";

const schema = yup.object().shape({
    email: yup.string().email("O e-mail deve ser válido").required("Este campo é obrigatório"),
    password: yup.string().required("Este campo é obrigatório")
});

const Login = () => {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { register, control, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });
    const navigate = useNavigate();
    const user = useSelector(state => state.user);
    const dispatch = useGDDispatch();
    const [openRecuperarSenha, setOpenRecuperarSenha] = useState(false);

    //let Logo = "";
    const [logo, setLogo] = useState("");

    useEffect(() => {
        const recuperarImagens = async () => {
            try {

                setIsLoading(true);

                const response = await servLogin.recuperarImages();

                dispatch(setImages(response));

                setLogo(response.Content.UrlLogoFull);

                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);
                console.log("erro" + err);
            }
        }

        const recuperarDadosPaginaLogin = async () => {
            try {
                const response = await servLogin.recuperarDadosPaginaLogin();
                const tituloSistema = document.getElementById("TituloSistema");
                const TituloAbaP3Tec = { tituloAba: response.Content.TituloAbaP3Tec }; 
        
                localStorage.setItem('TituloAbaP3Tec', JSON.stringify(TituloAbaP3Tec));
         
                if(TituloAbaP3Tec) {
                    const tituloAba = JSON.parse(localStorage.getItem('TituloAbaP3Tec')).tituloAba;
                    tituloSistema.textContent = tituloAba + " P3 Tec";
                }
            } catch (err) {
                console.log("erro" + err);
            }
        }

        recuperarDadosPaginaLogin();
        recuperarImagens();
    }, []);

    useEffect(() => {
        if (user && user.isAuthenticated) navigate("/");
    },[user]);

    const onClickLogin = handleSubmit( async (data) => {
        if (data.email.trim() === "" || data.password.trim() === "") {
            return;
        }

        try {
            setIsLoading(true);
            const response = await servLogin.login(data.email, data.password);

            
            dispatch(login(response.Content));
            dispatch(setEmail({Email: data.email}));
            setIsLoading(false);
        } catch (err) {
            setOpen(true);
            setErrorMessage(err?.response?.data?.Message);
            setIsLoading(false);
            return;
        }

        navigate("/");
    });

    const abrirRecuperacaoSenha = () => {
        setOpenRecuperarSenha(true);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpen(false);
        }

        setOpen(false);
    }

    return (
        <main className={styles.loginMain}>
            <div className={styles.loginCont} style={{ 
                width: "820px",
                height: "397px",
                borderRadius: "10px",
                display: "flex"
             }}>
                <div className={styles.leftContainer}>
                    <h1>Todo o controle que você precisa num lugar só!</h1>
                    <div className={styles.loginImage}>
                        <img className={styles.loginImageImage} src={LoginImage} alt="Mundo com duas pessoas" />
                    </div>
                </div>
                <div className={styles.rightContainer}>
                    <span className={styles.tituloLogin}></span>
                    <form onSubmit={onClickLogin}>
                    <Controller 
                        name="email"
                        control={control}
                        defaultValue=" "
                        render={({field}) => (
                            <FormControl variant="outlined" style={{ margin: '30px 44px 0 44px' }} > 
                            <InputLabel htmlFor="login-email" shrink style={{ color: "#B8B8B8" }}>E-mail</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="E-mail" 
                                type="email"
                                id="login-email" 
                                error={!!errors.email}
                                {...field} 
                                className={`${errors?.email ? styles.campoComValorErrado : ""}`} 
                            />
                            { errors.email ? 
                                ( <HelperText text={errors.email?.message} />  
                                ):  ( '' ) }
                            </FormControl>
                        )}
                    />

                    <Controller 
                        name="password"
                        control={control}
                        defaultValue=""
                        render={({field}) => (
                            <FormControl variant="outlined" style={{ margin: '30px 44px 0 44px' }}>
                            <InputLabel htmlFor="login-password" shrink style={{ color: "#B8B8B8" }}>Senha</InputLabel>
                            <WhiteInput 
                                fullWidth 
                                placeholder="****" 
                                type="password"
                                id="login-password" 
                                {...field}
                                error={!!errors.password}
                                className={`${errors?.password ? styles.campoComValorErrado : ""}`} 
                            />
                            { errors.password ? 
                                ( <HelperText text={errors.password?.message} />  
                                ):  ( '' ) }
                            </FormControl>   
                        )}
                    />
               
                    <div className={styles.buttonsContainer}>
                        <Link to="/cadastro">
                            <BlueHoverButton variant="contained">Cadastre-se</BlueHoverButton>
                        </Link>
                        <BlueHoverButton variant="contained" type="submit">Entrar</BlueHoverButton>
                        
                    </div>
                    <div className={styles.buttonsContainer}>
                        <a style={linkStyle} onClick={abrirRecuperacaoSenha}>
                                Esqueceu a senha?
                        </a>
                    </div>
                    </form>
                </div>
                <Popup title="Recuperação de senha" openPopup={openRecuperarSenha} setOpenPopup={setOpenRecuperarSenha} minHeight="100px">
                    <EsqueceuSenha
                        setOpenPopup={setOpenRecuperarSenha}
                    />
                </Popup>
                <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}> 
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
                </Snackbar>
            </div>
            <img src={logo} width={250} />
            <Modal open={isLoading}>
                    <Box style={modalStyle}>
                        <CircularProgress color="inherit" />
                    </Box>
            </Modal>
        </main>
    )
}

export { Login };